import { useSheetContext } from "@/context/sheet";
import { useCreateHotelRoom } from "@/hooks/hotel-rooms";
import { CreateHotelRoom } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute(
  "/(hotel-rooms)/hotel-rooms/$id/_sheet/new",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutateAsync } = useCreateHotelRoom(id, {
    onSuccess: (hotelRoom) => {
      close(() => {
        navigate({
          to: "/hotel-rooms/$id",
          params: { id: hotelRoom.id.toString() },
        });
      });
    },
  });

  const create = async (hotelRoom: CreateHotelRoom) => {
    await mutateAsync(hotelRoom);
  };

  return <Form onUpsert={create} hotelId={id} />;
}
